<template>
  <v-text-field 
    label="Surname"
    v-model="profile.lastName"
    @blur="submit"
    :loading="loading"
    :color="themes.candidate.light.input"
    @input="fixCase"
  />
</template>

<script>
// Mixins
import { caseConverters } from '@/mixins/caseConverters.js'

// Vue Component
export default {
  mixins: [caseConverters],

  props: ['value'],
  data() {
    return {
      // Loading indicator
      loading: false,
      // Model (object sent to API)
      profile: {
        lastName: this.value
      }
    }
  },
  methods: {
    fixCase() {
      this.profile.lastName = this.toTitleCase(this.profile.lastName)
    },

    submit() {
      if (this.value !== this.profile.lastName) {
        this.loading = true
        this.$store.dispatch('candidate/profile/update', this.profile).then(() => (this.loading = false))
      }
    }
  }
}
</script>
